import type { Component } from 'vue';
import type { ViewName } from '../model/viewFor.ts';
import GameOverContainer from './game-over/GameOverContainer.vue';
import GameAbandonedContainer from './GameAbandonedContainer.vue';
import GameStartingView from './GameStartingView.vue';
import LoadingView from './LoadingView.vue';
import LobbyHostContainer from './lobby/LobbyHostContainer.vue';
import LobbyPlayerView from './lobby/LobbyPlayerView.vue';
import ChooserChoosingContainer from './round/ChooserChoosingContainer.vue';
import ChooserRoundResultView from './round/ChooserRoundResultView.vue';
import ChooserWaitingView from './round/ChooserWaitingView.vue';
import GuesserGuessedView from './round/GuesserGuessedView.vue';
import GuesserGuessingContainer from './round/GuesserGuessingContainer.vue';
import GuesserRoundResultView from './round/GuesserRoundResultView.vue';
import GuesserWaitingView from './round/GuesserWaitingView.vue';

export const views = {
  ChooserChoosing: ChooserChoosingContainer,
  ChooserRoundResult: ChooserRoundResultView,
  ChooserWaiting: ChooserWaitingView,
  GameAbandoned: GameAbandonedContainer,
  GameOver: GameOverContainer,
  GameStarting: GameStartingView,
  GuesserGuessed: GuesserGuessedView,
  GuesserGuessing: GuesserGuessingContainer,
  GuesserRoundResult: GuesserRoundResultView,
  GuesserWaiting: GuesserWaitingView,
  Loading: LoadingView,
  LobbyHost: LobbyHostContainer,
  LobbyPlayer: LobbyPlayerView,
} satisfies Record<ViewName, Component>;
